import { ILibraryListScope, IScope } from "@/api";
import { createContext } from "react";

type ProcessingScope = IScope | ILibraryListScope;

export interface IProcessingScopesContext {
    processingScopes: Record<string, ProcessingScope>;
    addProcessingScope: (scope: ProcessingScope) => void;
    removeProcessingScope: (scopeId: string | number) => void;
    clearProcessingScopes: () => void;
}

export const ProcessingScopesContext =
    createContext<IProcessingScopesContext | null>(null);
